<template>
  <div class="flex flex-row items-center gap-2 p-2">
    <button
      class="flex-1 text-left font-semibold"
      :class="isOpen ? 'text-primary-500' : ''"
      @click="editionMode ? (isOpen = true) : null"
    >
      {{ label }}
    </button>
    <span v-if="editionMode" class="flex shrink-0 flex-row gap-3">
      <button @click="isOpen = true">
        <FontAwesomeIcon
          :icon="['fal', 'pen']"
          :class="isOpen ? 'text-gray-400' : 'text-primary-500'"
        />
      </button>
      <BaseDeleteButton v-if="item.deleteable" small @click="deleteItem" />
    </span>
  </div>
  <AddListItemFormComponent
    v-if="isOpen"
    :list-item="item"
    :group-name="groupName"
    @close="isOpen = false"
  />
</template>

<script>
import { mapActions } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import AddListItemFormComponent from '../../form/AddListItemFormComponent.vue'

/** A list item, as FM's ListItemRowComponent: edited in place. */
export default {
  name: 'ItemRowComponent',
  components: { AddListItemFormComponent, FontAwesomeIcon },
  props: {
    item: { type: Object, required: true },
    groupName: { type: String, required: true },
    editionMode: { type: Boolean, required: true }
  },
  data() {
    return { isOpen: false }
  },
  computed: {
    label() {
      const labels = this.item.label ?? {}
      return labels[this.$i18n.locale] ?? Object.values(labels)[0] ?? '-'
    }
  },
  methods: {
    ...mapActions({ deleteListItem: 'itemList/deleteListItemById' }),
    deleteItem() {
      // The row unmounts when the store drops the item: translate first.
      const message = this.$t('toasts.deleted_m', {
        var: this.$t('global.list_item')
      })
      const toast = this.$h.toastSuccess
      this.deleteListItem({ listItem: this.item.id }).then(() => toast(message))
    }
  }
}
</script>
